// PinPad — input PIN terkontrol: indikator titik + NumPad layar (rfc-006
// §2: NumPad untuk semua input angka termasuk PIN). Juga menerima keypad
// fisik (desktop) via listener keydown. Tak menyimpan state sendiri.
//
// Catatan: listener keydown global aman dipakai HANYA saat tak ada input
// teks lain di layar (mis. langkah PIN pada login). Render bersyarat.

import { useEffect } from "react";
import { NumPad } from "@ds/pos";
import { cn } from "@ds/lib/utils";

export interface PinPadProps {
  value: string;
  onChange: (next: string) => void;
  onSubmit?: () => void;
  max?: number;
}

export function PinPad({ value, onChange, onSubmit, max = 6 }: PinPadProps) {
  useEffect(() => {
    function onKey(event: KeyboardEvent) {
      if (event.key >= "0" && event.key <= "9") {
        if (value.length < max) onChange(value + event.key);
      } else if (event.key === "Backspace") {
        onChange(value.slice(0, -1));
      } else if (event.key === "Enter") {
        onSubmit?.();
      } else {
        return;
      }
      event.preventDefault();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [value, max, onChange, onSubmit]);

  return (
    <div className="space-y-5">
      <div className="flex justify-center gap-3" role="status" aria-label={`PIN ${value.length} digit`}>
        {Array.from({ length: max }).map((_, index) => (
          <span
            key={index}
            className={cn(
              "size-3.5 rounded-full border transition-colors",
              index < value.length ? "border-primary bg-primary" : "border-border-strong",
            )}
            aria-hidden
          />
        ))}
      </div>
      <NumPad
        onDigit={(digit) => {
          if (value.length < max) onChange(value + digit);
        }}
        onBackspace={() => onChange(value.slice(0, -1))}
        onClear={() => onChange("")}
      />
    </div>
  );
}
